import ChangeAbstract from "../abstract/ChangeAbstract";
import React from "react";

class ChangeFormatted extends ChangeAbstract {
  render() {
    const change = this.getChange();
    if (change === null) return null;
    const rate = this.getChangeRate();
    return (
      <>
        {rate === 1 ? "+" : ""}
        {change}{this.props.unit}
      </>
    );
  }
}

export default ChangeFormatted;
